// extracted by mini-css-extract-plugin
export default {"cls1":"Popover-cls1_vwS","cls2":"Popover-cls2_bwd Popover-cls1_vwS"};